import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import { withTranslation } from "react-i18next"
import { Link, useHistory } from "react-router-dom"
import {
  Badge,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  Row,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap"
import {
  getListUsers,
  removeUser,
  resetPassword,
  resetUser2FA,
  searchUser,
} from "services/users/calls"
import { CSVLink } from "react-csv"
import moment from "moment"
import toast from "components/Toast/Toast"

const List = props => {
  const { reRender, t } = props

  const [modalRedefinePass, setModalRedefinePass] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [confirm, setConfirm] = useState({})

  const [isLoading, handleLoading] = useState(true)

  const [total, setTotal] = useState(0)
  const [limit] = useState(10)
  const [offset, setOffset] = useState(0)
  const [query, setQuery] = useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const [pages, setPages] = useState([])
  const [isFirstPage, setIsFirstPage] = useState(true)
  const [isLastPage, setIsLastPage] = useState(false)

  const [users, setUsers] = useState([])
  const [totalActiveUsers, setTotalActiveUsers] = useState([])
  const [csvUsersList, setCsvUsersList] = useState([])
  const [newPassword, setNewPassword] = useState(false)
  const [hasError, setError] = useState(false)
  let history = useHistory()

  // TODO:
  // Mudar editar usuário abrir um modal

  const initPageOptions = {
    sizePerPage: limit,
    // totalSize: 0,
    custom: true,
    showTotal: true,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    prePageText: "Anterior",
    nextPageText: "Próximo",
    paginationTotalRenderer: (from, to, size) => {
      return (
        <div className="d-inline">
          <span className="react-bootstrap-table-pagination-total">
            Registros Retornados: {size}
          </span>
        </div>
      )
    },
  }

  const [pageOptions, setPageOptions] = useState(initPageOptions)

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  const selectRow = {
    mode: "checkbox",
    hideSelectColumn: true,
  }

  const columns = [
    {
      dataField: "id",
      text: "#",
      sort: true,
      formatter: (cellContent, row) => <b>{cellContent}</b>,
    },
    {
      dataField: "login",
      text: "Usuário",
      sort: false,
      formatter: (cellContent, row) => {
        return (
          <>
            <i
              className={`mdi mdi-circle me-2 text-${
                row?.isActive ? "success" : "danger"
              }`}
            />
            {cellContent}
          </>
        )
      },
    },
    {
      dataField: "name",
      text: "Nome",
      sort: false,
      formatter: (cellContent, row) => cellContent || 0,
    },
    {
      dataField: "email",
      text: "Email",
      sort: false,
      formatter: (cellContent, row) => cellContent || "-",
    },
    {
      dataField: "documentId",
      text: "Documento",
      sort: false,
      formatter: (cellContent, row) => cellContent || "-",
    },
    {
      dataField: "role.name",
      text: "Acesso",
      sort: false,
      formatter: (cellContent, row) => cellContent || "-",
    },
    {
      dataField: "channel.name",
      text: "Canal de Atd.",
      sort: false,
      formatter: (cellContent, row) => cellContent || "-",
    },
    {
      dataField: "isMfaEnabled",
      text: "Autenticador 2FA",
      sort: false,
      align: "center",
      formatter: (cellContent, row) =>
        cellContent ? (
          <Badge className="badge-soft-primary me-1">
            <b>Sim</b>
          </Badge>
        ) : (
          <Badge className="badge-soft-warning me-1">
            <b>Não</b>
          </Badge>
        ),
    },
    {
      dataField: "deletedAt",
      text: "Situaçao",
      sort: false,
      align: "center",
      formatter: (cellContent, row) =>
        cellContent ? (
          <Badge className="badge-soft-warning me-1">
            <b>Inativo</b>
          </Badge>
        ) : (
          <Badge className="badge-soft-primary me-1">
            <b>Ativo</b>
          </Badge>
        ),
    },
    {
      dataField: "options",
      isDummyField: true,
      text: "Opções",
      align: "center",
      formatter: (cellContent, row) => {
        if (!row.deletedAt) {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              {row?.isMfaEnabled && (
                <li>
                  <Link
                    to="#"
                    className="btn btn-sm btn-soft-primary"
                    onClick={() => {
                      setConfirm({
                        title: "Confirmação",
                        body: "Tem certeza que deseja redefinir o autenticador do usuário?",
                        onConfirm: () => {
                          onReset2FA(row.id)
                        },
                      })
                      setShowConfirm(true)
                    }}
                  >
                    <i
                      className="mdi mdi-two-factor-authentication"
                      id={`resetMFA${row?.id}`}
                    />
                    <UncontrolledTooltip
                      placement="top"
                      target={`resetMFA${row?.id}`}
                    >
                      Redefinir 2FA
                    </UncontrolledTooltip>
                  </Link>
                </li>
              )}
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-warning"
                  onClick={() => {
                    setConfirm({
                      title: "Confirmação",
                      body: "Tem certeza que deseja redefinir a senha do usuário?",
                      onConfirm: () => {
                        onResetPassword(row.id)
                      },
                    })
                    setShowConfirm(true)
                  }}
                >
                  <i
                    className="mdi mdi-lock-reset"
                    id={`resetPass${row?.id}`}
                  />
                  <UncontrolledTooltip
                    placement="top"
                    target={`resetPass${row?.id}`}
                  >
                    Redefinir Senha
                  </UncontrolledTooltip>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-info"
                  onClick={() => {
                    history.push(`/configuracoes/acessos/usuarios/${row.id}`)
                    props.setNav(3)
                  }}
                >
                  <i
                    className="mdi mdi-pencil-outline"
                    id={`editTooltip${row?.id}`}
                  />
                  <UncontrolledTooltip
                    placement="top"
                    target={`editTooltip${row?.id}`}
                  >
                    Editar
                  </UncontrolledTooltip>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={() => {
                    setConfirm({
                      title: "Confirmação",
                      body: (
                        <div>
                          <p>Essa ação é irreversivel!</p>
                          <p>
                            Por favor, confirme se tem certeza que deseja apagar
                            este usuário?
                          </p>
                        </div>
                      ),
                      onConfirm: () => {
                        onDeleteUser(row.id)
                      },
                    })
                    setShowConfirm(true)
                  }}
                >
                  <i
                    className="mdi mdi-delete-forever"
                    id={`deleteTooltip${row?.id}`}
                  />
                  <UncontrolledTooltip
                    placement="top"
                    target={`deleteTooltip${row?.id}`}
                  >
                    Excluir
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          )
        } else {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-info"
                  onClick={() => {
                    setConfirm({
                      title: "Confirmação",
                      body: (
                        <div>
                          <p>Ativar usuário?</p>
                        </div>
                      ),
                      onConfirm: () => {
                        onResetPassword(row.id)
                      },
                    })
                    setShowConfirm(true)
                  }}
                >
                  <i
                    className="mdi mdi-account-reactivate"
                    id="reativartooltip"
                  />
                  <UncontrolledTooltip placement="top" target="reativartooltip">
                    Reativar
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          )
        }
      },
    },
  ]

  const fetchUsers = async (query = "", offset = 0) => {
    try {
      handleLoading(true)
      setError(false)
      const { payload } = await searchUser(query, offset, limit)
      const { total, users, activeUsers } = payload
      setTotal(total)
      setUsers(users)
      setTotalActiveUsers(activeUsers)
      const pages = Math.ceil(total / limit)
      setPages(pages)
      setIsLastPage(users?.length + offset >= total)
      setIsFirstPage(offset === 0)
    } catch (err) {
      setError(err)
      console.error(err)
    } finally {
      handleLoading(false)
    }
  }

  useEffect(() => {
    setUsers([])
    setTotalActiveUsers(0)
    fetchUsers(query, offset)
  }, [query, reRender])

  const onResetPassword = async id => {
    handleLoading(true)
    try {
      const { payload } = await resetPassword(id)
      toast("sucess", "Senha redefinida com sucesso!", "")
    } catch (err) {
      toast("warning", "Falha ao redefinir senha.", "")
      console.log(err)
    } finally {
      handleLoading(false)
    }
  }

  const onReset2FA = async id => {
    resetUser2FA
    handleLoading(true)
    try {
      const { payload } = await resetUser2FA(id)
      toast("sucess", "Autenticador 2FA redefinido com sucesso!", "")
    } catch (err) {
      toast("warning", "Falha ao redefinir Autenticador.", "")
      console.log(err)
    } finally {
      handleLoading(false)
    }
  }

  const onDeleteUser = async id => {
    try {
      await removeUser(id)
      fetchUsers()
    } catch (err) {
      console.log(err)
    }
  }

  const snapToPage = page => {
    if (offset + limit * page >= 0) {
      const newOffset = offset + limit * page
      setOffset(newOffset)
      fetchUsers(query, newOffset)
      setCurrentPage(oldPage => oldPage + page)
      setIsFirstPage(newOffset === 0)
    }
  }

  const csvLinkRef = useRef()

  const handleExport = async () => {
    try {
      const {
        payload: { users },
      } = await getListUsers(query)
      const dataTratada = users.map(user => ({
        ID: user.id,
        Nome: user.name,
        Login: user.login,
        Email: user.email,
        Documento: user.documentId,
        Perfil: user.role.name,
        CriadoEm: moment(user.createdAt).format("DD/MM/YYYY HH:mm:ss"),
        ResetSenhaEm: user.passwordDate
          ? moment(user.passwordDate).format("DD/MM/YYYY HH:mm:ss")
          : "",
        UltimoAcessoEm:
          user.actions?.length > 0
            ? moment(user.actions[0].createdAt).format("DD/MM/YYYY HH:mm:ss")
            : "",
        InativacaoEm: user.deletedAt
          ? moment(user.deletedAt).format("DD/MM/YYYY HH:mm:ss")
          : "",
      }))
      setCsvUsersList(dataTratada)
      setTimeout(() => {
        csvLinkRef.current.link.click()
      }, 0)
    } catch (err) {
      console.error("Erro ao exportar:", err)
    }
  }

  return (
    <React.Fragment>
      <Row>
        <Col>
          <FormGroup>
            <Label>Pesquisa:</Label>
            <Input
              type="text"
              onChange={e => {
                setQuery(e.target.value)
              }}
            />
          </FormGroup>
        </Col>
        {users.length > 0 && total <= 200000 && (
          <Col xs={2} className="mt-3">
            <button
              className="btn btn-dark btn-block float-end"
              onClick={handleExport}
            >
              <i className="bx bx-export d-block"></i> Exportar CSV
            </button>
          </Col>
        )}
        <CSVLink
          data={csvUsersList}
          filename={`ListaUsuarios-${moment().format("DD_MM_YYYY_HH_mm")}.csv`}
          className="d-none"
          ref={csvLinkRef}
        />

        {users.length > 0 && total > 200000 && (
          <Col align="right" xs={2} className="mt-3">
            <mark style={{ color: "red" }}>
              <small>Excedeu 200 mil resgistros para exportação!</small>
            </mark>
          </Col>
        )}
      </Row>
      <Row>
        <Col>Usuários Ativos: {totalActiveUsers}</Col>
      </Row>
      {!isLoading &&
        (users?.length > 0 ? (
          <ToolkitProvider
            keyField="id"
            columns={columns}
            columnToggle
            data={users}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <Row>
                  <Col xl="12">
                    <div className="table-responsive">
                      <BootstrapTable
                        keyField={"id"}
                        responsive
                        bordered={true}
                        striped={true}
                        defaultSorted={defaultSorted}
                        selectRow={selectRow}
                        classes={"table align-middle table-nowrap"}
                        headerWrapperClasses={"thead-light"}
                        {...toolkitProps.baseProps}
                      />
                    </div>
                  </Col>
                </Row>
                {total > 0 && (
                  <Row className="align-items-md-center mt-30">
                    <Col className="inner-custom-pagination d-flex">
                      <div className="d-inline">
                        <span className="react-bootstrap-table-pagination-total">
                          {t("Registros Retornados")}: {total}
                        </span>
                      </div>
                      <div className="text-md-right ms-auto">
                        <button
                          className="btn btn-outline-primary "
                          disabled={isFirstPage || isLoading}
                          onClick={() => snapToPage(-1)}
                        >
                          {t("Anterior")}
                        </button>
                        <button
                          className="btn btn-outline-primary "
                          disabled={true}
                        >
                          {currentPage}/{pages}
                        </button>
                        <button
                          className="btn btn-outline-primary "
                          disabled={isLastPage || isLoading}
                          onClick={() => snapToPage(1)}
                        >
                          {t("Próximo")}
                        </button>
                      </div>
                    </Col>
                  </Row>
                )}
              </React.Fragment>
            )}
          </ToolkitProvider>
        ) : (
          <div style={{ textAlign: "center" }}>
            <h5>{t("Nenhum dado encontrado.")}</h5>
          </div>
        ))}
      {isLoading && (
        <div className="accordion-body" style={{ textAlign: "center" }}>
          <Spinner className="ms-2" color="primary" />
        </div>
      )}
      <Modal
        isOpen={modalRedefinePass}
        toggle={() => {
          setModalRedefinePass(!modalRedefinePass)
        }}
        centered
        onClosed={() => {
          fetchUsers(query, offset)
          setNewPassword(null)
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>Senha redefinida com sucesso! Anote a nova senha do usuário.</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setModalRedefinePass(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <h5>{`Senha : ${newPassword}`}</h5>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setModalRedefinePass(false)
            }}
            className="btn btn-secondary "
            data-dismiss="modal"
          >
            {props.t("Close")}
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={showConfirm}
        toggle={() => {
          setShowConfirm(!showConfirm)
        }}
        centered
        onClosed={() => {
          fetchUsers(query, offset)
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>{confirm?.title}</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              {
                confirm
              }
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">{confirm?.body}</div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
            }}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            {props.t("Cancelar")}
          </button>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              confirm?.onConfirm()
            }}
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {props.t("Confirmar")}
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

List.propTypes = {
  t: PropTypes.any,
  reRender: PropTypes.bool,
  setUserId: PropTypes.func,
  setNav: PropTypes.func,
}

export default withTranslation()(List)
